<ng-container *ngIf="filter.isReady">
    <mat-form-field class="no-labels no-helpers">
        <mat-select
            [attr.name]="context + '-select'"
            [ngModel]="filter.selected"
            (selectionChange)="onSelectionChanged($event)"
            [placeholder]="filter.placeholder | appTranslate"
        >
            <mat-option *ngFor="let option of filter.options" [value]="option">{{ option.label }}</mat-option>
        </mat-select>
    </mat-form-field>
</ng-container>
